import React from 'react';

import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { useStyles } from './styles';

type TextInputProps = {
  customIcon?: React.ReactNode;
} & TextFieldProps;

const KogInputTextSecondary = React.forwardRef(({ customIcon, ...props }: TextInputProps, ref: any) => {
  const styles = useStyles({});
  const defaultInputProps = {
    maxLength: 100,
  };

  return (
    <TextField
      fullWidth
      size='small'
      variant='outlined'
      ref={ref}
      className={styles.inputTextSecondary}
      inputProps={props.inputProps ? { ...defaultInputProps, ...props.inputProps } : defaultInputProps}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {customIcon}
          </InputAdornment>
        )
      }}
      {...props}
    />
  );
});

export default KogInputTextSecondary;
